package nl.astraeus.wiki.messages

class SavePageMessage() : Message(
  MessageType.SAVE_PAGE,
  MessageHeader.PAGE_ID,
) {

  constructor(msg: String) : this() {
    this.message = msg
  }

  constructor(pageId: Long, content: String) : this() {
    setHeader(MessageHeader.PAGE_ID, pageId.toString())
    setBody(content)
  }
}
